import anime from "animejs";
import EventEmitter2 from "eventemitter2";

import { $ } from "@utils/dom";

class MaskMediaCircle extends EventEmitter2 {
  constructor(el) {
    super();

    this.el = el;
    this.mask = $('.mask-media-circle__mask', this.el);
    this.img = $('.mask-media-circle__img', this.el);

    this._animated = false;
    this._tween = { value: 0.001 };

    this.init();
  }

  init() {
    if( this.mask ) this.mask.style.transform = `scale(0)`;
  }
  destroy() {
    if( this._tween ) anime.remove(this._tween);

    this.el = null;
    this.mask = null;
    this.img = null;

    this._animated = null;
    this._tween = null;
  }

  animateReverse(delay = 0){
    // if delay is not provided, get value from --delay css variable
    if( delay <= 0 ) delay = getComputedStyle(this.el).getPropertyValue('--delay');

    // animate a dummy object that will update transformations of mask and img on each frame
    anime({
      targets: this._tween,
      value: 0.001,
      duration: 750,
      delay: delay,
      easing: 'easeInQuad',
      update: () => {
        if( this.mask ) this.mask.style.transform = `scale(${this._tween.value})`;
        if( this.img ) this.img.style.transform = `scale(${1 / this._tween.value})`;
      }
    });
  }

  animate(delay = 0) {
    // if component is already animated, skip here
    if( this._animated ) return;
    this._animated = true;

    // if delay is not provided, get value from --delay css variable
    if( delay <= 0 ) delay = getComputedStyle(this.el).getPropertyValue('--delay');

    // animate a dummy object that will update transformations of mask and img on each frame
    anime({
      targets: this._tween,
      value: [0.001, 1],
      duration: 1150,
      delay: delay,
      easing: 'easeOutCubic',
      update: () => {
        if( this.mask ) this.mask.style.transform = `scale(${this._tween.value})`;
        if( this.img ) this.img.style.transform = `scale(${1 / this._tween.value})`;
      }
    });
  }

  reset() {
    // remove previous animation (will do nothing if there is no animation running)
    anime.remove(this._tween);

    // reset animation status
    this._animated = false;
  }
}

export default MaskMediaCircle;
